import { vehicleStatuses } from './constants';

/** Human-readable line for notifications / UI (e.g. cable, lists). */
export const formatVehicleLabel = (vehicle) =>
  [vehicle?.year, vehicle?.make, vehicle?.model].filter(Boolean).join(' ') || 'Vehicle';

/** Matches vehicle detail "Add to Auction" eligibility (storage threshold, not yet on Towlot, still in storage). */
export const isVehicleReadyForAuction = ({
  status,
  has_towlot_vehicle,
  storage_days,
  suggested_days_for_auction
}) => {
  if (has_towlot_vehicle) return false;
  if (status === vehicleStatuses.RELEASED || status === vehicleStatuses.TAKEN_OUT) return false;
  if (suggested_days_for_auction == null) return false;
  return Number(storage_days) >= Number(suggested_days_for_auction);
};
